'use client'

import { ReactNode, startTransition, useCallback, useState } from 'react'

import dynamic from 'next/dynamic'

import { ErrorBoundary } from 'react-error-boundary'

import useAddEventListener from '@hooks/useAddEventListener'
import useIsomorphicEffect from '@hooks/useClientSideLayoutEffect'

import styles from './carousel.module.scss'

type CarouselProps = {
  children: ReactNode
}

const Glider = dynamic(() => import('react-glider'))

export default function Carousel({ children }: CarouselProps): JSX.Element {
  const [mobile, setMobile] = useState<boolean>(false)
  const handleResize = useCallback((): void => {
    startTransition(() => {
      const width = window.innerWidth
      if (width > 768) {
        setMobile(false)
      } else {
        setMobile(true)
      }
    })
  }, [])

  useIsomorphicEffect(() => {
    handleResize()
  }, [handleResize])

  useAddEventListener('resize', handleResize)

  if (mobile) {
    return (
      <ErrorBoundary fallback={<></>}>
        <div className={styles['mobile-wrap']}>
          <Glider draggable id="categories" duration={1.5} className={styles.carousel}>
            {children}
          </Glider>
        </div>
      </ErrorBoundary>
    )
  }

  return <div className={styles.carousel}>{children}</div>
}
